import { MaintenanceTeamMember } from "@/components/calendar/CalendarTypes";
import { ListModel } from "@/shared/models/listModel";
import Vue from "vue";
import { ActionTree, GetterTree, MutationTree } from "vuex";

const initialState = {

    maintenanceTeam: [] as MaintenanceTeamMember[]
};

const state = { ...initialState };

const getters: GetterTree<typeof state, any> = {
    maintenanceTeam: s => s.maintenanceTeam
};

const actions: ActionTree<typeof state, any> = {
    refreshMaintenanceTeam({ commit }) {
        return Vue.axios
            .get<ListModel<MaintenanceTeamMember>>("/maintenance/getMaintenanceTeamMembers")
            .then((res) => {
                commit("setMaintenanceTeam", res.data.result);
            });
    },
}

const mutations: MutationTree<typeof state> = {
    setMaintenanceTeam: (state, value) => {
        state.maintenanceTeam = value.slice();
    },
}

export default {
    namespaced: true,
    state: () => state,
    getters,
    actions,
    mutations,
};